<template>
	<ul @mouseenter="showTooltip" @mouseleave="hideTooltip">
		<li>
			{{ dynamicError }} <a v-if="allLink" href="/selection-slate/?code=ALLLAW&contract=groups" target="_blank">Upgrade Now</a>
		</li>
	</ul>
</template>
<script>
import AddExistingHelp from "./addExistingHelp.js";
import IconToolTip from "../../components/ui/IconTooltip.vue";

export default {
	props: {
		tileError: {
			type: Number,
			required: false,
			default: 0,
		},
		tooltip: {
			type: Boolean,
			default: false,
		},
	},
	computed: {		
		dynamicError() {
			let errorMsg = this.tileError;
			return errorMsg === AddExistingHelp.INCOMPATIBLE ? `This file format cannot be added. Upload your file in .pdf, .jpg, .jpeg, .png, .doc, .docx, .rtf, .xlsx, . xls, .ppt or .pptx format.` : 
				errorMsg === AddExistingHelp.ACCOUNT ? `Upgrade your account to add this document.` : 
				errorMsg === AddExistingHelp.SIZE ? `File must be under 30 MB.` :
				errorMsg === AddExistingHelp.ESIGN ? `eSign documents cannot be added.` :
				errorMsg === AddExistingHelp.BLANK ? `Empty files cannot be added.` : `This document cannot be notarized online`;
		},
		allLink() {
			return this.tileError === AddExistingHelp.ACCOUNT;
		}
	},
	methods: {
		showTooltip() {
			return IconToolTip.tooltip = true;
		},
		hideTooltip() {
			return IconToolTip.tooltip = false;
		},
	},
};
</script>